import { render, staticRenderFns } from "./PlayerInComplaints.vue?vue&type=template&id=1f02cb2c&scoped=true&"
import script from "./PlayerInComplaints.vue?vue&type=script&lang=js&"
export * from "./PlayerInComplaints.vue?vue&type=script&lang=js&"
import style0 from "./PlayerInComplaints.vue?vue&type=style&index=0&id=1f02cb2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f02cb2c",
  null
  
)

export default component.exports